import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-pro-react.scss?v1.0.0";
import "assets/scss/style.scss";
import "antd/dist/antd.css";
import { Provider } from "react-redux";
import myStore from "./store/createStore";
import setupAxiosInterceptors from "./globals/interceptors";
import App from "./app";

require("dotenv-expand")(
  require("dotenv").config({
    path: "../.env",
  })
);

const store = myStore();
setupAxiosInterceptors(store);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,

  document.getElementById("root")
);
